import {
  baseSemanticColor
} from "./chunk-AUP6IESS.mjs";
import {
  __spreadValues
} from "./chunk-LK3IYL3P.mjs";

// src/utils/createColorTheme.ts
var createColorTheme = (partialColors) => {
  return __spreadValues(__spreadValues({}, baseSemanticColor), partialColors);
};

export {
  createColorTheme
};
